import React, { useEffect } from 'react'
import { navigate } from 'gatsby'
import Layout from '../../components/LayoutNew'

const PaymentPage = () => {
  useEffect(() => {
    navigate('/', { replace: true })
  }, [])

  return (
    <Layout>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '60vh',
        }}
      >
        <p style={{ fontSize: '18px', color: '#999' }}>页面已下线</p>
      </div>
    </Layout>
  )
}

export default PaymentPage
